import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import BlotFormatter from "quill-blot-formatter";
import ImageBlot from './ImageBlot';

Quill.register('modules/imageResize', BlotFormatter);
Quill.register(ImageBlot);

const Link = Quill.import('formats/link')

class linkType extends Link {
  static create(value) {
    let node = super.create(value)
    value = this.sanitize(value)
    if (value.startsWith('https://tonaliteh.com')) {
      node.removeAttribute('target')
    }
    return node
  }
}
Quill.register(linkType)

const modules = {
  toolbar: [
    [
      { 'header': [1, 2, 3, 4, 5, false] }, // Add explicit header levels
      { 'font': [] }
    ],
    [{ 'size': [] }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'align': [] }],
    [{ 'direction': 'rtl' }],
    ['link', 'image'],
    ['clean'], // remove formatting button
  ],
  imageResize: {
    modules: ['Resize', 'DisplaySize', 'Toolbar'],
  },
};

const formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'script',
  'align', 'direction', 'link', 'image',
  'color', 'background',
];

const RichTextEditor = ({ value, onChange }) => {

  return (
    <div className="text-gray-800" dir='ltr'>
      <ReactQuill
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        theme="snow"
        className="bg-white rounded-md"
      />
    </div>
  );
};

export default RichTextEditor;